/**
 * Review widget: filter/sort + load-more pagination + date "ago"
 */
function getTimeAgo(isoDateStr) {
  if (!isoDateStr || typeof isoDateStr !== 'string') return '';
  const date = new Date(isoDateStr.trim());
  if (Number.isNaN(date.getTime())) return isoDateStr;
  const now = new Date();
  const diffMs = now - date;
  const diffSec = Math.floor(diffMs / 1000);
  const diffMin = Math.floor(diffSec / 60);
  const diffHour = Math.floor(diffMin / 60);
  const diffDay = Math.floor(diffHour / 24);
  const diffWeek = Math.floor(diffDay / 7);
  const diffMonth = Math.floor(diffDay / 30);
  const diffYear = Math.floor(diffDay / 365);
  if (diffSec < 60) return 'Just now';
  if (diffMin < 60) return diffMin === 1 ? '1 minute ago' : diffMin + ' minutes ago';
  if (diffHour < 24) return diffHour === 1 ? '1 hour ago' : diffHour + ' hours ago';
  if (diffDay < 7) return diffDay === 1 ? '1 day ago' : diffDay + ' days ago';
  if (diffWeek < 4) return diffWeek === 1 ? '1 week ago' : diffWeek + ' weeks ago';
  if (diffMonth < 12) return diffMonth === 1 ? '1 month ago' : diffMonth + ' months ago';
  return diffYear === 1 ? '1 year ago' : diffYear + ' years ago';
}

function fillDateAgo(container) {
  const scope = container || document;
  scope.querySelectorAll('[data-review-date-iso]').forEach((el) => {
    const val = el.getAttribute('data-review-date-iso');
    el.textContent = getTimeAgo(val || '');
  });
}

document.querySelectorAll('[data-review-widget]').forEach((widget) => {
  const list = widget.querySelector('[data-review-widget-list]');
  const starSelect = widget.querySelector('[data-review-widget-star]');
  const orderSelect = widget.querySelector('[data-review-widget-order]');
  const loadMoreButton = widget.querySelector('[data-review-widget-load-more]');

  const cards = list ? Array.from(list.querySelectorAll('.review-widget__card')) : [];
  const initialVisible = parseInt(widget.getAttribute('data-initial-visible') || '3', 10);
  const batchSize = parseInt(widget.getAttribute('data-batch-size') || '3', 10);
  let currentVisible = initialVisible;

  function apply() {
    if (!list) return;
    const star = starSelect?.value ?? 'all';
    const order = orderSelect?.value ?? 'desc';

    // filter
    const filtered = cards.filter((card) => {
      const rating = card.getAttribute('data-rating');
      return star === 'all' || rating === star;
    });

    // sort by original index
    const indices = filtered.map((c) => parseInt(c.getAttribute('data-index'), 10));
    if (order === 'asc') indices.sort((a, b) => a - b);
    else indices.sort((a, b) => b - a);

    const orderMap = new Map(indices.map((idx, i) => [idx, i]));
    filtered.sort((a, b) => {
      const aIdx = parseInt(a.getAttribute('data-index'), 10);
      const bIdx = parseInt(b.getAttribute('data-index'), 10);
      return (orderMap.get(aIdx) ?? 0) - (orderMap.get(bIdx) ?? 0);
    });

    // reset visibility
    cards.forEach((card) => {
      card.hidden = true;
    });

    const maxToShow = Math.min(currentVisible, filtered.length);
    for (let i = 0; i < maxToShow; i += 1) {
      const card = filtered[i];
      card.hidden = false;
      list.appendChild(card);
    }

    if (loadMoreButton) {
      loadMoreButton.hidden = filtered.length <= maxToShow;
    }
    fillDateAgo(widget);
  }

  function resetAndApply() {
    currentVisible = initialVisible;
    apply();
  }

  starSelect?.addEventListener('change', resetAndApply);
  orderSelect?.addEventListener('change', resetAndApply);

  loadMoreButton?.addEventListener('click', () => {
    currentVisible += batchSize;
    apply();
  });

  if (list) {
    apply();
    fillDateAgo(widget);
  }

  // Write review modal
  const openBtn = widget.querySelector('[data-review-widget-open-form]');
  const modal = widget.querySelector('[data-review-widget-modal]');
  const form = widget.querySelector('.review-widget__form');
  if (openBtn && modal) {
    const open = () => {
      modal.classList.add('is-open');
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    };
    const close = () => {
      modal.classList.remove('is-open');
      modal.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
    };
    openBtn.addEventListener('click', (e) => {
      e.preventDefault();
      e.stopPropagation();
      open();
    });
    widget.querySelectorAll('[data-review-widget-close]').forEach((el) => el.addEventListener('click', close));
    modal.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') close();
    });
  }
  if (form) {
    const bodyField = form.querySelector('input[name="contact[body]"]');
    const ratingSelect = form.querySelector('[data-review-rating]');
    const titleInput = form.querySelector('[data-review-title]');
    const textArea = form.querySelector('[data-review-text]');
    const nameInput = form.querySelector('input[name="contact[name]"]');
    const emailInput = form.querySelector('input[name="contact[email]"]');
    const formFields = form.querySelector('.review-widget__form-fields');
    const successEl = form.querySelector('.review-widget__form-success-js');
    const submitBtn = form.querySelector('[data-review-form-submit]');
    const modal = form.closest('[data-review-widget-modal]');
    const webhookUrl =
      widget.getAttribute('data-review-webhook-url') ||
      (modal && modal.getAttribute('data-review-webhook-url')) ||
      '';
    const web3formsKey =
      widget.getAttribute('data-review-web3forms-key') ||
      (modal && modal.getAttribute('data-review-web3forms-key')) ||
      '';

    function buildReviewBody(rating, title, text, productHandle, productTitle, page) {
      const lines = [
        '--- Store review submission ---',
        'Rating: ' + rating,
        'Title: ' + title,
        '',
        'Review:',
        text,
        '',
        'Submitted from: ' + page
      ];
      if (productHandle) {
        lines.splice(2, 0, 'Product: ' + (productTitle || productHandle), 'Product handle: ' + productHandle);
      }
      return lines.join('\n');
    }

    async function submitViaWebhook(url, payload) {
      const formBody = new URLSearchParams();
      formBody.append('name', payload.name || '');
      formBody.append('email', payload.email || '');
      formBody.append('subject', payload.subject || '');
      formBody.append('message', payload.message || '');
      formBody.append('rating', payload.rating || '');
      formBody.append('title', payload.title || '');
      formBody.append('productTitle', payload.productTitle || '');
      formBody.append('productHandle', payload.productHandle || '');
      formBody.append('page', payload.page || '');

      const res = await fetch(url, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });
      const data = await res.json().catch(() => ({}));
      if (!res.ok || data.success === false) {
        throw new Error(data.error || data.message || 'Webhook request failed');
      }
    }

    async function submitViaWeb3Forms(payload) {
      const formBody = new URLSearchParams();
      formBody.append('access_key', payload.access_key);
      formBody.append('from_name', payload.from_name || 'Customer');
      formBody.append('email', payload.email || '');
      formBody.append('subject', payload.subject || 'Product review');
      formBody.append('message', payload.message || '');

      const res = await fetch('https://api.web3forms.com/submit', {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded' },
        body: formBody.toString()
      });
      const data = await res.json().catch(() => ({}));
      const success = res.ok && (data.success === true || data.success === 'true');
      if (!success) {
        const msg = (data.body && data.body.message) || data.message || 'Failed to send review';
        throw new Error(typeof msg === 'string' ? msg : 'Failed to send review');
      }
    }

    function handleSubmit(e) {
      if (e) {
        e.preventDefault();
        e.stopPropagation();
      }
      if (!bodyField || (successEl && !successEl.hidden)) return;
      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      const rating = ratingSelect?.value ?? '';
      const title = titleInput?.value.trim() ?? '';
      const text = textArea?.value.trim() ?? '';
      const page = typeof window !== 'undefined' && window.location ? window.location.href : '';
      const productHandle = widget.getAttribute('data-product-handle');
      const productTitle = widget.getAttribute('data-product-title');
      const bodyText = buildReviewBody(rating, title, text, productHandle, productTitle, page);
      const name = (nameInput && nameInput.value) ? nameInput.value.trim() : 'Customer';
      const email = (emailInput && emailInput.value) ? emailInput.value.trim() : '';
      const subject = 'Product review' + (productTitle ? ': ' + productTitle : '');
      const originalText = submitBtn ? submitBtn.textContent : '';
      const showSuccess = () => {
        if (formFields) formFields.hidden = true;
        if (successEl) successEl.hidden = false;
      };
      const showError = (err) => {
        console.error('[Review widget] Submit failed:', err);
        alert(err.message || 'Could not send review. Please try again.');
      };
      const resetButton = () => {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = originalText;
        }
      };

      if (webhookUrl) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-loading-text') || 'Sending…';
        }
        submitViaWebhook(webhookUrl, {
          name,
          email,
          subject,
          rating,
          title,
          body: text,
          message: bodyText,
          productHandle: productHandle || '',
          productTitle: productTitle || '',
          page
        })
          .then(showSuccess)
          .catch(showError)
          .finally(resetButton);
        return;
      }

      if (web3formsKey) {
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = submitBtn.getAttribute('data-loading-text') || 'Sending…';
        }
        submitViaWeb3Forms({
          access_key: web3formsKey,
          from_name: name,
          email: email,
          subject: subject,
          message: bodyText
        })
          .then(showSuccess)
          .catch(showError)
          .finally(resetButton);
        return;
      }

      bodyField.value = bodyText;
      form.setAttribute('target', '_blank');
      form.submit();
      form.removeAttribute('target');
      if (formFields) formFields.hidden = true;
      if (successEl) successEl.hidden = false;
    }

    if (submitBtn) {
      submitBtn.addEventListener('click', handleSubmit);
    }
    form.addEventListener('submit', handleSubmit);
  }
});

(function attachProductReviewSummary() {
  if (typeof document === 'undefined') return;
  const widget = document.querySelector('[data-review-widget][data-review-average][data-review-count]');
  const summaryEl = document.querySelector('[data-product-review-summary]');
  if (!widget || !summaryEl) return;

  const avg = widget.getAttribute('data-review-average');
  const count = widget.getAttribute('data-review-count');
  if (!avg || !count) return;

  const avgNum = Number(avg);
  const fullStars = Math.round(isNaN(avgNum) ? 0 : avgNum);
  const stars = '★★★★★'.split('').map((ch, i) => (i < fullStars ? ch : '☆')).join('');

  summaryEl.innerHTML = `
    <span class="product-review-summary__stars" aria-label="${avg} out of 5 stars">
      ${stars}
    </span>
    <span class="product-review-summary__text">
      ${avg} (${count} reviews)
    </span>
  `;
}());
